module.exports = __webpack_public_path__ + "static/media/cashflow-up-btn-selected.59e67f38.svg";